import axios from 'axios'

import store from '../store'

// Request interceptor
axios.interceptors.request.use((request) => {
  const token = store.getters['auth/token']
  if (token) {
    request.headers['Authorization'] = `Bearer ${token}`
  }

  request.headers['X-Timezone'] = Intl.DateTimeFormat().resolvedOptions().timeZone

  return request
})

// Response interceptor
axios.interceptors.response.use(
  (response) => response,
  (thrown) => {
    // if we purposefully canceled a request
    if (axios.isCancel(thrown)) {
      return Promise.reject(thrown)
    }
    // else if an error was thrown
    else {
      const { status } = thrown.response

      if (status >= 500) {
        console.error('Server error:', thrown.response?.data?.message || 'Something went wrong')
      }

      if (status === 401 && store.getters['auth/check']) {
        store.commit('auth/LOGOUT')
        let current_url = window.location.href
        window.location = config.public_url + '/login?continue=' + encodeURIComponent(current_url)
      }

      return Promise.reject(thrown)
    }
  },
)
